/**
 * TCR-2605 — thứ tự ưu tiên khi HIỂN THỊ phí vận chuyển.
 *
 * Bối cảnh: vận đơn mới tạo chỉ có báo giá của hãng (`fee_estimate`), chưa có
 * phí thật (`fee_actual`). Màn hình trước đây in ra `0 ₫` hoặc `—`, người dùng
 * tưởng đơn miễn phí vận chuyển trong khi thực ra hãng đã báo một khoản phí.
 *
 * Quy tắc (một chỗ duy nhất, hai màn dùng lại):
 *   1. Phí đã CHỐT (thật hoặc người thu) → hiện số đó, KHÔNG gắn nhãn.
 *   2. Chưa có phí chốt → hiện báo giá của hãng, gắn nhãn "(ước tính)".
 *   3. Không có gì → không hiện số nào.
 *
 * `0` nghĩa là "chưa biết", KHÔNG phải "miễn phí" — cùng quy ước với
 * `effectiveShippingFee` ở `src/pages/Shipping/parts/columns.tsx`.
 *
 * Hàm này CHỈ lo phần hiển thị: không đụng `summary.shipping_cost` hay bất kỳ
 * số hạch toán nào.
 */

/** Phí đã chốt (thật hoặc người thu). `0`/`null` = chưa biết. */
export interface ShippingFeeDisplayInput {
  actual?: number | null;
  /** Phí hãng báo giá lúc tạo vận đơn. */
  estimate?: number | null;
}

export interface ShippingFeeDisplayResult {
  /** Số tiền cần hiển thị; `null` = không có phí nào để hiện. */
  amount: number | null;
  /** `true` nếu số trên là BÁO GIÁ của hãng, chưa phải phí thật. */
  isEstimate: boolean;
}

/** Nhãn gắn cạnh số tiền khi đó là phí ước tính. */
export const SHIPPING_FEE_ESTIMATE_LABEL = '(ước tính)';

/** Giải thích cho nhãn ước tính (tooltip). */
export const SHIPPING_FEE_ESTIMATE_HINT =
  'Phí hãng báo giá lúc tạo vận đơn, sẽ được cập nhật khi hãng báo phí thật.';

export function resolveShippingFeeDisplay(
  input: ShippingFeeDisplayInput,
): ShippingFeeDisplayResult {
  const actual = Number(input.actual ?? 0);
  if (actual > 0) {
    return { amount: actual, isEstimate: false };
  }
  const estimate = Number(input.estimate ?? 0);
  if (estimate > 0) {
    return { amount: estimate, isEstimate: true };
  }
  return { amount: null, isEstimate: false };
}
